import {apiSlice} from '../apiSlice';

const ROLE_URL = '/roles';

export const roleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: (data) => ({
                url: `${ROLE_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": data
                }
            }),
        }),
        newRole: builder.mutation({
            query: ({token, data}) => ({
                url: `${ROLE_URL}/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            })
        }),
        getOneRole: builder.query({
            query: ({token, id}) => ({
                url: `${ROLE_URL}/${id}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            })
        }),
        updateOneRole: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${ROLE_URL}/update/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    "x-access-token": token
                }
            })
        }),
        deleteOneRole: builder.mutation({
            query: ({token, id}) => ({
                url: `${ROLE_URL}/delete/${id}`,
                method: 'DELETE',
                headers: {
                    "x-access-token": token
                }
            })
        })
    }),
});

export const {
    useUpdateOneRoleMutation,
    useDeleteOneRoleMutation,
    useGetOneRoleQuery,
    useNewRoleMutation,
    useGetRolesQuery,
} = roleApiSlice;
